import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs/internal/observable/throwError';
import { environment } from '../../../../environments/environment';
import { CostGenericDoc } from '../../_models/financials';

@Injectable()
export class CostGenericDocsService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getList(): Observable<CostGenericDoc[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/financial/costGenericDocs')
      .pipe(map((response) => response));
  }

  get(id: number): Observable<CostGenericDoc> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/financial/costGenericDocs/' + id)
      .pipe(map((response) => response));
  }

  save(costGenericDocItem): Observable<CostGenericDoc> {
    const costGenericDoc = { ...costGenericDocItem };
    delete costGenericDoc.lastUpdated;
    delete costGenericDoc.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    costGenericDoc.companyId = companySelected ? companySelected.id : null;

    if (costGenericDoc.user != null && costGenericDoc.user.id != null) {
      costGenericDoc.user = { id: costGenericDoc.user.id };
    }

    if (costGenericDoc.id) {
      return this.http
        .put<CostGenericDoc>(
          this.apiBaseUrl + 'api/private/v1/financial/costGenericDocs/' + costGenericDoc.id,
          costGenericDoc
        )
        .pipe(
          catchError((error: any) => {
            console.error('Error in PUT request:', error);
            return throwError(error);
          })
        );
    } else {
      return this.http
        .post<CostGenericDoc>(
          this.apiBaseUrl + 'api/private/v1/financial/costGenericDocs/',
          costGenericDoc
        )
        .pipe(
          catchError((error: any) => {
            console.error('Error in POST request:', error);
            return throwError(error);
          })
        );
    }
  }

  delete(id: number): Observable<CostGenericDoc> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/financial/costGenericDocs/' + id)
      .pipe(
        map(() => {
          return { id } as CostGenericDoc;
        })
      );
  }
}
